<template>
  <component
    :is="isMarqetaCardProductsEnabled() ? 'MarqetaDisplayCard' : 'MarqetaDisplayCardLegacy'"
    :token="token"
    :cardOnly="cardOnly"
    :elevation="elevation"
    :magicLink="magicLink"
    @get-cards="(source) => $emit('get-cards', source)"
    @reset="$emit('reset')"
    @scrollToTop="$emit('scrollToTop')"
  />
</template>

<script>
import MarqetaDisplayCard from "@/components/wallet/MarqetaDisplayCard.vue";
import MarqetaDisplayCardLegacy from "@/components/wallet/MarqetaDisplayCardLegacy.vue";
import featureFlags from "@/mixins/featureFlags";

// Remove with feature-marqeta-card-products (192399), along with MarqetaDisplayCardLegacy.
export default {
  name: "MarqetaVirtualCard",
  components: { MarqetaDisplayCard, MarqetaDisplayCardLegacy },
  mixins: [featureFlags],
  props: {
    token: String,
    cardOnly: Boolean,
    elevation: {
      type: Boolean,
      default: true,
    },
    magicLink: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["get-cards", "reset", "scrollToTop"],
};
</script>
